import { render, staticRenderFns } from "./GStudentRecordGrowth.vue?vue&type=template&id=1bc13c76&scoped=true&"
import script from "./GStudentRecordGrowth.vue?vue&type=script&lang=ts&"
export * from "./GStudentRecordGrowth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc13c76",
  null
  
)

export default component.exports